import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { TransactionsApi } from '@shared/api/rest';
import type { TransactionResponse, UpdateTransactionRequest } from '@shared/api/rest/transactions';

const effect = createEffect((request: UpdateTransactionRequest) => TransactionsApi.updateTransaction(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransactionResponse | null>(null)
  .on(effect.done, (current, result) => result.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $updateTransactionStore = {
  events: {
    update: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
